/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type users_set_input = {
    active?: boolean | null | undefined;
    address_id?: string | null | undefined;
    created_at?: string | null | undefined;
    email?: string | null | undefined;
    first_name?: string | null | undefined;
    last_name?: string | null | undefined;
    phone?: string | null | undefined;
    updated_at?: string | null | undefined;
    user_id?: string | null | undefined;
};
export type ProfileLastNameMutationVariables = {
    user_id: string;
    data?: users_set_input | null | undefined;
};
export type ProfileLastNameMutationResponse = {
    readonly update_users_by_pk: {
        readonly id: string;
        readonly last_name: string | null;
    } | null;
};
export type ProfileLastNameMutation = {
    readonly response: ProfileLastNameMutationResponse;
    readonly variables: ProfileLastNameMutationVariables;
};



/*
mutation ProfileLastNameMutation(
  $user_id: uuid!
  $data: users_set_input
) {
  update_users_by_pk(pk_columns: {user_id: $user_id}, _set: $data) {
    id
    last_name
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "data"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "user_id"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "_set",
        "variableName": "data"
      },
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "user_id",
            "variableName": "user_id"
          }
        ],
        "kind": "ObjectValue",
        "name": "pk_columns"
      }
    ],
    "concreteType": "users",
    "kind": "LinkedField",
    "name": "update_users_by_pk",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "last_name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileLastNameMutation",
    "selections": (v2/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProfileLastNameMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "c80fb44de1141c8208ddaeb3807c6199",
    "id": null,
    "metadata": {},
    "name": "ProfileLastNameMutation",
    "operationKind": "mutation",
    "text": "mutation ProfileLastNameMutation(\n  $user_id: uuid!\n  $data: users_set_input\n) {\n  update_users_by_pk(pk_columns: {user_id: $user_id}, _set: $data) {\n    id\n    last_name\n  }\n}\n"
  }
};
})();
(node as any).hash = 'df0de1eb7227634386cce88672d31a3c';
export default node;
